import { Event } from '../Event'
import { Identity } from '../../constants'

export interface CuratedListExpertNoteHelpfulEventProperties {
  sellable_id: string
  note_id: string
}

export class CuratedListExpertNoteHelpfulEvent extends Event<
  CuratedListExpertNoteHelpfulEventProperties
> {
  static displayName = 'Curated List Expert Note Helpful'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
